import React from "react";

function About() {
  return (
    <section className="section-3" id="section-about">
      <div className="row">
        <div className="about-sec">
          <h2>About Me</h2>
          <div className="about-grid">
            <div className="avatar" data-aos="fade-right"></div>
            <div className="toolkit" data-aos="fade-left">
              <div className="toolkit-left">
                <p>
                  Resourceful Full stack web developer bringing in-depth
                  knowledge of latest technology trends, libraries and frameworks to produce superb real-time web
                  applications.
                </p>
                <div className="button">
                  <a
                    href="/doc/daniel_cv.pdf"
                    target="_blank"
                    className="btn-full"
                  >
                    Download cv
                  </a>
                </div>
              </div>
              <div className="toolkit-right">
                <div className="progress-1">
                  <p>Website Development</p>
                  <progress value="95" max="100">
                    95%
                  </progress>
                </div>
                <div className="progress-2">
                  <p>Web App Development</p>
                  <progress value="90" max="100">
                    90%
                  </progress>
                </div>
                <div className="progress-3">
                  <p>Mobile App Development</p>
                  <progress value="85" max="100">
                    95%
                  </progress>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
